export const normalizeColorsMode = res => {
    return !res || !res.IsLightMode;
};
